import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const posOrderRemarkAtom = atomWithStorage<string>("posOrderRemarkAtom", "");

const usePosOrderRemarkAtom = () => {
  const atom = useAtom(posOrderRemarkAtom);
  return atom;
};

export const useSetPosOrderRemark = () => useSetAtom(posOrderRemarkAtom);

export default usePosOrderRemarkAtom;
